module.exports = __webpack_public_path__ + "static/media/example.7f2e5acf.png";